import { hyphenateString } from "./getAutomationId.helpers";

export const getDataAutomationGroup = (group: string | undefined = "") => ({
  "data-automation-group": hyphenateString(group) || undefined,
});
